import React, { useState, useEffect } from "react";
import { uploadToCloudinary } from "../utils/cloudinaryUpload";
import { addTestimonial } from "../utils/firebaseCRUD";
import "./UploadTestimonial.css";

function UploadTestimonial() {
  const [form, setForm] = useState({
    name: "",
    stars: "",
    description: "",
  });
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const personImageUrl = await uploadToCloudinary(image);
      await addTestimonial({
        ...form,
        stars: parseInt(form.stars),
        personImageUrl,
        createdAt: new Date(),
      });
      alert("Review added successfully!");
      setForm({ name: "", stars: "", description: "" });
      setImage(null);
    } catch (err) {
      console.error(err);
      alert("Error adding review");
    }
    setLoading(false);
  };

  useEffect(()=>{
    if(!image){ setPreview(null); return }
    const url = URL.createObjectURL(image);
    setPreview(url);
    return ()=> URL.revokeObjectURL(url);
  },[image]);

  return (
    <div className="upload-testimonial-container">
      <div className="upload-card">
        <h2>Add Testimonial</h2>
        <form className="upload-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <label className="form-label">Name</label>
            <input type="text" placeholder="Name" value={form.name} onChange={(e)=>setForm({...form, name:e.target.value})} required />
          </div>

          <div className="form-row">
            <label className="form-label">Rating</label>
            <div className="stars-input">
              {[1,2,3,4,5].map(n=> (
                <button key={n} type="button" className={`star ${Number(form.stars)>=n? 'active':''}`} onClick={()=>setForm({...form, stars: String(n)})} aria-label={`${n} stars`}>
                  ★
                </button>
              ))}
            </div>
          </div>

          <div className="form-row">
            <label className="form-label">Description</label>
            <textarea placeholder="Description" value={form.description} onChange={(e)=>setForm({...form, description:e.target.value})} required />
          </div>

          <div className="form-row image-row">
            <div>
              <label className="form-label">Photo</label>
              <input type="file" accept="image/*" onChange={(e)=>setImage(e.target.files[0])} required />
            </div>
            <div className="image-preview">{preview? <img src={preview} alt="preview"/>: <div className="placeholder">No photo</div>}</div>
          </div>

          <div className="form-actions">
            <button className="btn primary" type="submit" disabled={loading}>{loading? 'Uploading...':'Add Testimonial'}</button>
            <button type="button" className="btn ghost" onClick={()=>{ setForm({name:'',stars:'',description:''}); setImage(null); setPreview(null); }}>Reset</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default UploadTestimonial;